import { render, staticRenderFns } from "./WhatsappBasicPlanCard.vue?vue&type=template&id=96b948ca&scoped=true"
import script from "./WhatsappBasicPlanCard.vue?vue&type=script&lang=js"
export * from "./WhatsappBasicPlanCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b948ca",
  null
  
)

export default component.exports